<template>
    <van-nav-bar :title="tools.GetLanguageValue('public.app.套餐')" />
    <div class="collection_title_menu">
      <div class="collection_content">
        <div class="collection_items">
          <div
            class="collection_item"
            v-for="item in CollectionList"
            :key="item.Id"
          >
            <van-card
              currency=""
              :price="item.PriceFormat"
              :desc="item.Desc"
              :title="item.Name"
              thumb="https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg"
            >
              <template #tags> </template>
              <template #footer>
                <!-- 查看详细 -->
                <van-button
                  size="small"
                  icon="plus"
                  @click="GetCollectionDetail(item)"
                ></van-button>
                <!-- <van-button
                  size="small"
                  icon="plus"
                  @click="AddCollection(item)"
                ></van-button> -->
              </template>
            </van-card>
          </div>
        </div>
      </div>

      <!-- 套餐信息 -->
      <van-action-sheet
        v-model:show="DetailCollectionWindow"
        :title="tools.GetLanguageValue('public.app.详细信息')"
        :style="{ height: '80%' }"
      >
        <van-button
          block
          type="primary"
          size="small"
          icon="plus"
          @click="AddCollectionConfirm(CollectionOpt)"
          > {{ tools.GetLanguageValue("public.app.新增") }}</van-button
        >

        <div class="productsubdivisions_title">
          <div> {{ tools.GetLanguageValue("public.app.可选数量") }}</div>
        </div>

        <div class="productSubdivisions">
          <div class="productsubdivisions_info">
            <van-badge :content="CollectionOpt.Rest">
               {{ tools.GetLanguageValue("public.app.其他") }}</van-badge
            >
          </div>
          <div class="productsubdivisions_info">
            <van-badge :content="CollectionOpt.Drinks">
               {{ tools.GetLanguageValue("public.app.饮料") }}</van-badge
            >
          </div>
          <div class="productsubdivisions_info">
            <van-badge :content="CollectionOpt.Sweetmeats">
               {{ tools.GetLanguageValue("public.app.甜点") }}</van-badge
            >
          </div>
          <div class="productsubdivisions_info">
            <van-badge :content="CollectionOpt.Foodstuff">
               {{ tools.GetLanguageValue("public.app.食品") }}</van-badge
            >
          </div>
        </div>
        <br />
        <p
          style="padding: 5px"
          v-if="CollectionOpt.StoreCollectionItemResults.length > 0"
        >

          {{ tools.GetLanguageValue("public.app.请继续点餐") }}
        </p>
        <div
          v-for="(item, index) in CollectionOpt.StoreCollectionItemResults"
          :key="index"
        >
          <div class="edit_collection">
            <van-row>
              <van-col span="16">
                <van-button type="primary" block @click="EditCollection(item)"
                  >
                  {{ tools.GetLanguageValue("public.app.继续点餐") }}</van-button
                ></van-col
              >
              <van-col span="6"
                >
                {{ tools.GetLanguageValue("public.app.已选") +  item.ItemCount  }} </van-col
              >
            </van-row>
          </div>
        </div>
      </van-action-sheet>

      <br />
      <br />
      <br />
      <br />
      <br />
    </div>

    <TakeOutTabbar active="storeshoppingcart" />
  </template>
<script >
import axios from "../../commons/AxiosMethod.js"
import tools from "../../commons/tools.js"
import productBbroadwise from "../../components/productBroadwise.vue"
import TakeOutTabbar from "../../components/tabbars/TakeOutTabbar.vue"
import { showToast } from "vant"
import { Collapse, CollapseItem, Tab, Tabs, showDialog } from "vant"
export default {
  data () {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      tools: tools,
      TableId: "",
      active: "",
      CollectionList: [], // 合集列表
      CollectionOpt: {}, // 当前分类

      DetailCollectionWindow: false
    }
  },
  name: "App",
  mounted () {
    this.TableId = localStorage.getItem("Cache-TableId")
    this.GetCollections()
  },
  components: {
    productBbroadwise,
    TakeOutTabbar
  },
  methods: {
    AddCollectionConfirm (item) {
      if (this.CollectionOpt.StoreCollectionItemResults.length == 0) {
        this.AddCollection(item)
      } else {
        showDialog.confirm({
          title: tools.GetLanguageValue("public.app.添加提示"),
          message:
              "您已经添加了" +
              this.CollectionOpt.StoreCollectionItemResults.length +
              "个套餐，确定要继续添加吗？"
        })
          .then(() => {
            this.AddCollection(item)
          })
          .catch(() => {
            // on cancel
          })
      }
    },
    // 继续点餐
    EditCollection (item) {
      this.$router.push({
        path: "takeOutCollectionItems",
        query: {
          cartId: item.Id,
          collectionId: this.CollectionOpt.ProductId
        }
      })
    },
    // 查看详细
    GetCollectionDetail (item) {
      this.DetailCollectionWindow = true
      this.CollectionOpt = item

      axios.apiMethod(
        "/TakeOuts/ShoppingTrolley/GetCollectionById",
        "get",
        {
          collectionId: item.Id
          // shoppingItemId: guid
        },
        (result) => {
          this.CollectionOpt = result.Data
          this.DetailCollectionWindow = true
        }
      )
    },
    // 获取合集
    GetCollections () {
      axios.apiMethod(
        "/TakeOuts/ShoppingTrolley/GetTakeOutCollectionList",
        "get",
        {},
        (result) => {
          this.CollectionList = result.Data
        }
      )
    },
    // 新增合集
    AddCollection (item) {
      axios.apiMethod(
        "/TakeOuts/ShoppingTrolley/AddShoppingCart",
        "post",
        {
          ProductId: item.CollectionId,
          Count: 1,
          Remarks: "",
          TableId: tools.guid()
        },
        (result) => {
          if (result.Data.IsSuccess) {
            this.$router.push({
              path: "takeOutCollectionItems",
              query: {
                cartId: result.Data.Model,
                collectionId: item.CollectionId
              }
            })
          } else {
            showToast(result.Data.Msg)
          }
        }
      )
    }
  }
}
</script>
  <style lang="scss" scoped>
  .collection_title_menu {
    .collection_content {
      .collection_items {
        background-color: #fff;
        .collection_item {
          margin-top: 10px;
        }
      }
    }
  }
  .productSubdivisions {
    width: 100%;
    height: 40px;
    display: flex;
    justify-items: center;

    .productsubdivisions_info {
      width: 24%;
      padding: 2px;
      text-align: center;
      border: 1px solid #eee;
    }
  }
  .productsubdivisions_title {
    padding: 10px 20px;
    font-size: 13pt;
    border-bottom: 1px solid #eee;
  }
  .edit_collection {
    padding: 10px;
    height: 35px;
    line-height: 35px;
    text-align: center;
  }
  </style>
